import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { fetch, setDadosPesq } from "../actions";
import SelectBasico from "./SelectBasico";
import { SubTitulo } from "./Diversos";
import { usePesq } from './Hooks/Pesq';

function Func(props) {
  const [dados, loading] = usePesq(props.fetch, props.pesq, props.setDadosPesq, props.modelo);

  return (
    <>
      {props.title && <SubTitulo>{props.title}</SubTitulo>}
      <SelectBasico {...props} dados={props.pesq[props.modelo] || []} loading={loading} />
    </>
  );
}

const mapStateToProps = state => {
  return { pesq: state.pesq };
};

export default connect(mapStateToProps, { fetch, setDadosPesq })(Func);
